import React from 'react';

/**
 * FAQ visible + indexable — le format préféré des moteurs et des IA (AEO).
 * Le contenu doit rester STRICTEMENT aligné avec le Schema.org FAQPage
 * déclaré dans public/index.html (règle Google : FAQ visible = FAQ balisée).
 */
const FAQ = [
  {
    q: "Le Family's est-il un restaurant halal ?",
    r: "Oui, le Family's est un restaurant 100% halal à Bourg-en-Bresse : toutes nos viandes sont halal certifiées, et l'établissement ne sert pas d'alcool.",
  },
  {
    q: "Peut-on commander en ligne ?",
    r: "Oui : commandez en ligne en quelques clics, via notre application mobile (avec 5% de remise fidélité), ou en livraison via Uber Eats.",
  },
  {
    q: "Quels sont les horaires du Family's ?",
    r: "Nous sommes ouverts du mardi au dimanche, de 11h30 à 14h00 et de 18h00 à minuit. Fermé le lundi.",
  },
  {
    q: "Où se trouve le restaurant ?",
    r: "Au 59 rue du 14 Juillet 1789, 01000 Bourg-en-Bresse. Sur place, à emporter ou en livraison — appelez-nous au 04 74 52 60 82.",
  },
];

const FaqSection = () => (
  <section className="py-12 sm:py-16 bg-gradient-to-b from-amber-950 to-orange-950 animate-on-scroll">
    <div className="container mx-auto px-4">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-white text-center mb-8">
          Questions <span className="text-orange-400">fréquentes</span>
        </h2>
        <div className="space-y-3">
          {FAQ.map((item, i) => (
            <details
              key={i}
              className="group rounded-2xl bg-white/10 backdrop-blur-sm border border-white/20 open:border-orange-400/50 transition-colors"
            >
              <summary className="cursor-pointer list-none px-5 py-4 text-white font-semibold text-base sm:text-lg flex items-center justify-between gap-3">
                {item.q}
                <span className="text-orange-400 transition-transform group-open:rotate-45 text-2xl leading-none shrink-0">+</span>
              </summary>
              <p className="px-5 pb-5 text-gray-200 text-sm sm:text-base leading-relaxed">{item.r}</p>
            </details>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default FaqSection;
